__turbopack_context__.v({
  "cardImage": "Mmkqya_cardImage",
  "cardLink": "Mmkqya_cardLink",
  "date": "Mmkqya_date",
  "electric": "Mmkqya_electric",
  "figure": "Mmkqya_figure",
  "root": "Mmkqya_root",
});
